import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 10.252C6 6.832 8.653 4 12 4s6 2.833 6 6.252c0 1.84-1.129 3.813-2.281 5.443a43.976 43.976 0 01-1.774 2.308l-.277.34c-.44.541-.805.99-1.058 1.343a.75.75 0 01-1.22 0 30.643 30.643 0 00-1.058-1.343l-.277-.34a44.003 44.003 0 01-1.774-2.308C7.129 14.065 6 12.091 6 10.252zm6 2.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 9.001a7.5 7.5 0 1115 0c0 1.205-.385 2.576-.934 3.928-.555 1.364-1.302 2.767-2.08 4.055a39.918 39.918 0 01-2.307 3.405c-.688.905-1.316 1.632-1.711 1.947a.75.75 0 01-.936 0c-.395-.315-1.023-1.042-1.711-1.947a39.916 39.916 0 01-2.306-3.405c-.78-1.288-1.526-2.691-2.08-4.056-.55-1.351-.935-2.722-.935-3.927zM12 12.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 18.002C9 9.717 15.715 3 24 3s15 6.717 15 15.002c0 2.41-.77 5.151-1.868 7.855-1.11 2.728-2.603 5.535-4.161 8.11a79.802 79.802 0 01-4.613 6.81c-1.375 1.81-2.633 3.266-3.422 3.896a1.5 1.5 0 01-1.872 0c-.789-.63-2.047-2.085-3.422-3.895a79.802 79.802 0 01-4.613-6.81c-1.558-2.576-3.052-5.383-4.16-8.111C9.768 23.153 9 20.41 9 18.002zM24 24.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    clipRule: "evenodd"
  }))
};
export var LocationPinFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});